<template>
  <div class="relative">
    <div class="bg-light-yellow fixed top-0 left-0 right-0 bottom-0 z-negative">
      <div class="w-56 h-56 absolute rounded-full blue-circle"></div>
      <div class="w-112 h-112 absolute rounded-full pink-circle"></div>
      <div class="w-16 h-16 absolute rounded-full purple-circle"></div>
      <div class="w-20 h-20 absolute rounded-full grey-circle"></div>
      <div class="rounded-full yellow-circle absolute">
        <StripedCircle :height="128" :width="128"/>
      </div>
    </div>

    <!-- default -->
    <section v-if="showBig" class="h-full flex justify-center pt-5 pb-4 ">
      <div class="min-w-28 w-128 h-128 bg-light-green rounded-full flex flex-col items-center">
        <div class="w-32 h-32 min-h-8 bg-light-yellow flex justify-center items-center rounded-full mt-2">
          <svg fill="none" height="53" viewBox="0 0 71 53" width="71" xmlns="http://www.w3.org/2000/svg">
            <g id="box">
              <path id="Shape" clip-rule="evenodd"
                    d="M61.4598 23.7106L68.3988 36.1383H71V40.2626H68.3988L61.4598 52.6903H9.54035L2.60121 40.2626H0V36.1383H2.60121L9.54035 23.7106H61.4598ZM59.0077 27.8352H11.9923L7.35627 36.1384H24.0675H46.9324H63.644L59.0077 27.8352ZM41.6583 40.2626L41.3521 41.5301H29.6479L29.3417 40.2626H41.6583ZM11.9923 48.5659H59.0077L63.644 40.2626H45.9363L44.6338 45.6545H26.3667L25.064 40.2626H7.35627L11.9923 48.5659Z"
                    fill="#F75F39"
                    fill-rule="evenodd"/>
              <path id="Path"
                    d="M22.1638 6.58567C22.1638 5.4587 22.3673 5.01263 22.7047 4.2736C23.1332 3.33455 23.6665 2.16594 23.6665 0H19.9099C19.9099 1.12696 19.7064 1.57303 19.369 2.31207C18.9405 3.25111 18.4072 4.41987 18.4072 6.58581C18.4072 8.75189 18.9405 9.92065 19.369 10.8597C19.7063 11.5989 19.9099 12.0451 19.9099 13.1723C19.9099 14.2996 19.7063 14.7456 19.369 15.485C18.9405 16.424 18.4072 17.5928 18.4072 19.7588H22.1638C22.1638 18.6316 22.3674 18.1854 22.7047 17.4462C23.1332 16.5072 23.6665 15.3383 23.6665 13.1723C23.6665 11.0062 23.1332 9.83749 22.7047 8.8983C22.3674 8.15912 22.1638 7.71291 22.1638 6.58567Z"
                    fill="#F75F39"/>
              <path id="Path_2"
                    d="M31.3679 6.58567C31.3679 5.4587 31.5714 5.01263 31.9088 4.2736C32.3373 3.33455 32.8706 2.1658 32.8706 0H29.114C29.114 1.12696 28.9105 1.57303 28.5731 2.31207C28.1446 3.25111 27.6113 4.41987 27.6113 6.58567C27.6113 8.75175 28.1446 9.9205 28.5731 10.8595C28.9104 11.5987 29.114 12.0449 29.114 13.1722C29.114 14.2994 28.9104 14.7455 28.5731 15.4848C28.1445 16.424 27.6113 17.5928 27.6113 19.7588H31.3679C31.3679 18.6316 31.5716 18.1854 31.9088 17.4462C32.3373 16.5072 32.8706 15.3383 32.8706 13.1723C32.8706 11.0062 32.3373 9.83749 31.9088 8.8983C31.5716 8.15912 31.3679 7.71291 31.3679 6.58567Z"
                    fill="#F75F39"/>
              <path id="Path_3"
                    d="M41.8865 6.58567C41.8865 5.4587 42.0901 5.01263 42.4273 4.2736C42.8558 3.33455 43.3891 2.1658 43.3891 0H39.6325C39.6325 1.12696 39.4289 1.57303 39.0917 2.31207C38.6632 3.25111 38.1299 4.41987 38.1299 6.58567C38.1299 8.75175 38.6632 9.9205 39.0917 10.8595C39.4289 11.5987 39.6325 12.0449 39.6325 13.1722C39.6325 14.2994 39.4289 14.7455 39.0917 15.4848C38.6632 16.424 38.1299 17.5928 38.1299 19.7588H41.8865C41.8865 18.6316 42.0901 18.1854 42.4273 17.4462C42.8558 16.5072 43.3891 15.3383 43.3891 13.1723C43.3891 11.0062 42.8558 9.83749 42.4273 8.8983C42.0901 8.15912 41.8865 7.71291 41.8865 6.58567Z"
                    fill="#F75F39"/>
              <path id="Path_4"
                    d="M51.0896 6.58567C51.0896 5.4587 51.2932 5.01263 51.6304 4.2736C52.059 3.33455 52.5923 2.16594 52.5923 0H48.8357C48.8357 1.12696 48.632 1.57303 48.2948 2.31207C47.8663 3.25111 47.333 4.41987 47.333 6.58581C47.333 8.75189 47.8663 9.92065 48.2948 10.8597C48.632 11.5989 48.8357 12.0451 48.8357 13.1723C48.8357 14.2996 48.632 14.7456 48.2948 15.485C47.8663 16.424 47.333 17.5928 47.333 19.7588H51.0896C51.0896 18.6316 51.2932 18.1854 51.6304 17.4462C52.059 16.5072 52.5923 15.3383 52.5923 13.1723C52.5923 11.0062 52.059 9.83749 51.6304 8.8983C51.2932 8.15912 51.0896 7.71291 51.0896 6.58567Z"
                    fill="#F75F39"/>
            </g>
          </svg>
        </div>
        <h1 class="text-4xl text-black font-semibold mt-4 mb-4">BuildaBox</h1>
        <p class="mb-6 px-10 sm:px-12 mt-3 text-center">
          BuildaBox.co is an innovative way to personalize any event, project or program. And it's free. Try it now.
        </p>
        <div class="flex mt-5">
          <a
              class="mr-3 sm:mt-0 w-68 sm:w-40" @click="createOrder">
            <button class="btn btn-primary font-semibold w-full h-16 rounded-lg sm:rounded shadow-primary"
                    type="button">
              <Spinner v-if="create_buildabox_order_loading" class="mx-auto"/>
              <span v-else>
                Order from
              <span class="block">BuildaBox</span>
              </span>

            </button>
          </a>
          <router-link :to="{name: 'segmentation-wizard'}" class="sm:mt-0 w-50 sm:w-40">
            <button class="btn btn-primary font-semibold w-full h-16 rounded-lg sm:rounded shadow-primary"
                    type="button">
              Produce an
              <span class="block">Event</span>
            </button>
          </router-link>
        </div>

      </div>
    </section>

    <!-- Small height desctop screen -->
    <section v-if="!showBig" class="h-full flex justify-center pt-5 pb-4 ">
      <div class="w-68 h-68 bg-light-green rounded-full flex flex-col items-center">
        <div class="w-auto h-auto p-3 bg-light-yellow flex justify-center items-center rounded-full mt-2">
          <svg fill="none" height="30" viewBox="0 0 71 53" width="30" xmlns="http://www.w3.org/2000/svg">
            <g id="box">
              <path id="Shape" clip-rule="evenodd"
                    d="M61.4598 23.7106L68.3988 36.1383H71V40.2626H68.3988L61.4598 52.6903H9.54035L2.60121 40.2626H0V36.1383H2.60121L9.54035 23.7106H61.4598ZM59.0077 27.8352H11.9923L7.35627 36.1384H24.0675H46.9324H63.644L59.0077 27.8352ZM41.6583 40.2626L41.3521 41.5301H29.6479L29.3417 40.2626H41.6583ZM11.9923 48.5659H59.0077L63.644 40.2626H45.9363L44.6338 45.6545H26.3667L25.064 40.2626H7.35627L11.9923 48.5659Z"
                    fill="#F75F39"
                    fill-rule="evenodd"/>
              <path id="Path"
                    d="M22.1638 6.58567C22.1638 5.4587 22.3673 5.01263 22.7047 4.2736C23.1332 3.33455 23.6665 2.16594 23.6665 0H19.9099C19.9099 1.12696 19.7064 1.57303 19.369 2.31207C18.9405 3.25111 18.4072 4.41987 18.4072 6.58581C18.4072 8.75189 18.9405 9.92065 19.369 10.8597C19.7063 11.5989 19.9099 12.0451 19.9099 13.1723C19.9099 14.2996 19.7063 14.7456 19.369 15.485C18.9405 16.424 18.4072 17.5928 18.4072 19.7588H22.1638C22.1638 18.6316 22.3674 18.1854 22.7047 17.4462C23.1332 16.5072 23.6665 15.3383 23.6665 13.1723C23.6665 11.0062 23.1332 9.83749 22.7047 8.8983C22.3674 8.15912 22.1638 7.71291 22.1638 6.58567Z"
                    fill="#F75F39"/>
              <path id="Path_2"
                    d="M31.3679 6.58567C31.3679 5.4587 31.5714 5.01263 31.9088 4.2736C32.3373 3.33455 32.8706 2.1658 32.8706 0H29.114C29.114 1.12696 28.9105 1.57303 28.5731 2.31207C28.1446 3.25111 27.6113 4.41987 27.6113 6.58567C27.6113 8.75175 28.1446 9.9205 28.5731 10.8595C28.9104 11.5987 29.114 12.0449 29.114 13.1722C29.114 14.2994 28.9104 14.7455 28.5731 15.4848C28.1445 16.424 27.6113 17.5928 27.6113 19.7588H31.3679C31.3679 18.6316 31.5716 18.1854 31.9088 17.4462C32.3373 16.5072 32.8706 15.3383 32.8706 13.1723C32.8706 11.0062 32.3373 9.83749 31.9088 8.8983C31.5716 8.15912 31.3679 7.71291 31.3679 6.58567Z"
                    fill="#F75F39"/>
              <path id="Path_3"
                    d="M41.8865 6.58567C41.8865 5.4587 42.0901 5.01263 42.4273 4.2736C42.8558 3.33455 43.3891 2.1658 43.3891 0H39.6325C39.6325 1.12696 39.4289 1.57303 39.0917 2.31207C38.6632 3.25111 38.1299 4.41987 38.1299 6.58567C38.1299 8.75175 38.6632 9.9205 39.0917 10.8595C39.4289 11.5987 39.6325 12.0449 39.6325 13.1722C39.6325 14.2994 39.4289 14.7455 39.0917 15.4848C38.6632 16.424 38.1299 17.5928 38.1299 19.7588H41.8865C41.8865 18.6316 42.0901 18.1854 42.4273 17.4462C42.8558 16.5072 43.3891 15.3383 43.3891 13.1723C43.3891 11.0062 42.8558 9.83749 42.4273 8.8983C42.0901 8.15912 41.8865 7.71291 41.8865 6.58567Z"
                    fill="#F75F39"/>
              <path id="Path_4"
                    d="M51.0896 6.58567C51.0896 5.4587 51.2932 5.01263 51.6304 4.2736C52.059 3.33455 52.5923 2.16594 52.5923 0H48.8357C48.8357 1.12696 48.632 1.57303 48.2948 2.31207C47.8663 3.25111 47.333 4.41987 47.333 6.58581C47.333 8.75189 47.8663 9.92065 48.2948 10.8597C48.632 11.5989 48.8357 12.0451 48.8357 13.1723C48.8357 14.2996 48.632 14.7456 48.2948 15.485C47.8663 16.424 47.333 17.5928 47.333 19.7588H51.0896C51.0896 18.6316 51.2932 18.1854 51.6304 17.4462C52.059 16.5072 52.5923 15.3383 52.5923 13.1723C52.5923 11.0062 52.059 9.83749 51.6304 8.8983C51.2932 8.15912 51.0896 7.71291 51.0896 6.58567Z"
                    fill="#F75F39"/>
            </g>
          </svg>
        </div>
        <h1 class="text-xl text-black font-semibold mt-1 mb-1">BuildaBox</h1>
        <p class="mb-2 px-10 sm:px-12 text-center text-xs">
          BuildaBox.co is an innovative way to personalize any event, project or program. And it's free. Try it now.
        </p>
        <a
            class="sm:mt-0 mb-3" @click="$router.push(`/caterers/${caterer.uuid}/order`)">
          <button
              class="btn btn-primary font-semibold w-full h-8 rounded-lg sm:rounded shadow-primary text-xs px-3 py-2"
              type="button">
            Order from BuildaBox
          </button>
        </a>
        <router-link :to="{name: 'segmentation-wizard'}" class="sm:mt-0">
          <button
              class="btn btn-primary font-semibold w-full h-8 rounded-lg sm:rounded shadow-primary text-xs px-3 py-2"
              type="button">
            Produce an Event
          </button>
        </router-link>
      </div>
    </section>

  </div>
</template>

<script>
import StripedCircle from '../components/common/StripedCircle'
import Api from '@/api/api_v1.0'
import api_v1 from '@/api/api_v1.0'
import Spinner from '@/components/common/Spinner'

export default {
  name      : 'Home',
  components: {
    Spinner,
    StripedCircle
  },
  data () {
    return {
      height                        : 0,
      width                         : 0,
      caterer                       : {
        payments: []
      },
      create_buildabox_order_loading: false,
    }
  },
  async created () {
    window.addEventListener('resize', this.setWH)
    this.setWH()
    await this.getCatererInfo('buildabox')

  },
  beforeUnmount () {
    window.removeEventListener('resize', this.setWH)
  },
  computed: {
    isLandscape () {
      return this.width > this.height
    },
    showBig () {
      return this.isLandscape && this.height > 708
    },
  },
  methods : {
    async createOrder () {
      this.create_buildabox_order_loading = true
      const orderResponse = await api_v1.createBuildaboxOrder()
      await this.$store.commit('setCurrentEditingOrder', orderResponse.data)
      await this.$router.push(`/orders/${orderResponse.data.uuid}/edit`)
      this.create_buildabox_order_loading = false
    },
    setWH () {
      this.width = window.outerWidth
      this.height = window.outerHeight
    },
    async getCatererInfo (slug) {
      const response = await Api.getCatererBySlug(slug)
      this.caterer = response.data
    },
  }
}
</script>

<style scoped>
.blue-circle {
  background: #b6dff5;
  left: 60px;
  bottom: 100px;
}

.pink-circle {
  background: #fcad94;
  right: -120px;
  bottom: -120px;
}

.purple-circle {
  background: #de9ed2;
  right: 200px;
  top: 200px;
}

.grey-circle {
  background: #cccdbe;
  bottom: 100px;
  right: 400px;
}

.yellow-circle {
  top: 150px;
  left: 300px;
}
</style>
